import classes from '@styles/scss/pagination/pagination.module.scss';
import { SiteSmallType } from 'lib/types/item/siteSmalltype';
import Link from 'next/link';

export default function PaginationSite({
    siteName,
    siteSlug,
    categoryName,
    categorySlug,
    pagination
}: {
    siteName?: string;
    siteSlug?: string;
    categoryName: string;
    categorySlug: string;
    pagination: SiteSmallType[];
}): JSX.Element {
    const numberOfsites = pagination.length;
    const siteObj: any = {};

    let j = 1;
    // set the position
    pagination.map((item: any) => {
        const element: SiteSmallType = {
            position: j++,
            name: item.name,
            categorySlug: item.categorySlug
        };
        Object.assign(siteObj, { [item.slug]: element });
    });

    let slug = '';
    siteSlug ? (slug = siteSlug) : (slug = categorySlug);

    // current = 0 if site is orphan (not in the active site list)
    const current = siteObj[slug] ? siteObj[slug].position : 0;
    let prev, next: number;
    current == 0
        ? ((prev = numberOfsites), (next = current + 1))
        : current == 1
        ? (prev = numberOfsites)
        : (prev = current - 1);
    current == numberOfsites ? (next = 1) : (next = current + 1);

    let nextPage = '/' + pagination[next - 1].slug;
    let prevPage = '/' + pagination[prev - 1].slug;
    if (siteSlug) {
        nextPage = '/' + pagination[next - 1].categorySlug + nextPage;
        prevPage = '/' + pagination[prev - 1].categorySlug + prevPage;
    }

    return (
        <>
            <div className={classes.breadCrumbs}>
                <ul>
                    <li>
                        <Link prefetch={false} href="/">
                            <a id="Review">MyFavSexCams</a>
                        </Link>
                    </li>
                    <li>
                        <Link prefetch={false} href={'/' + categorySlug}>
                            <a id="Review">{categoryName}</a>
                        </Link>
                    </li>
                    {siteName && (
                        <li>
                            <span>{siteName}</span>
                        </li>
                    )}
                </ul>
                <div className={classes.navigation}>
                    <Link prefetch={false} href="/">
                        <a
                            id="ReviewHomeButton"
                            className={classes.button + ' ' + classes.home + ' ' + classes.tooltip}>
                            <i className="fa fa-home fa-lg" aria-hidden="true"></i>
                            <small className={classes.tooltiptext}>Back to Homepage</small>
                        </a>
                    </Link>{' '}
                    <Link prefetch={false} href={nextPage}>
                        <a
                            id="ReviewNextButton"
                            className={classes.button + ' ' + classes.next + ' ' + classes.tooltip}>
                            <i className="fa fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
                            <small className={classes.tooltiptext}>
                                Next Review: {pagination[next - 1].name}
                            </small>
                        </a>
                    </Link>{' '}
                    <Link prefetch={false} href={prevPage}>
                        <a
                            id="ReviewPreviousButton"
                            className={
                                classes.button + ' ' + classes.previous + ' ' + classes.tooltip
                            }>
                            <i className="fa fa-arrow-circle-left fa-lg" aria-hidden="true"></i>
                            <small className={classes.tooltiptext}>
                                Previous Review: {pagination[prev - 1].name}
                            </small>
                        </a>
                    </Link>
                </div>
            </div>
        </>
    );
}
